var image_viewer_rtlignore_default = {
  "fontElementMap": "qur7E",
  "imageContainer": "STRvg",
  "expandButton": "aXbKS",
  "expandIcon": "gxqdm",
  "pointer": "NsfnS",
  "imageWrapper": "M9fp3",
  "imageRatio": "OaQPN",
  "image": "P3CQS",
  "imageOverlay": "bC9nm",
  "imagePreload": "pXR-Q",
  "imageHighres": "NcGiy",
  "onlyHighRes": "_3EVHN",
  "image_loading": "H1HEB"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
